import { gql } from 'apollo-angular'

export const SUBSCRIPTION_WITH_PRICING_FIELDS = gql`
  fragment SubscriptionWithPricingFields on Subscription {
    id
    name
    product {
      id
      name
      magazine {
        id
        title
        archived
        media {
          cover {
            url
          }
        }
      }
    }
    scheduledChange {
      docs {
        id
        scheduled_for
        scheduledForDay
        product_options {
          id
          quantity
          product_option {
            id
            name
            type
            from_seats
            seat_value
            invoicing {
              price
              currency
              frequency
              tax_rate
            }
          }
          discount
          discount_percentage
          custom_price
        }
      }
    }
    product_options {
      id
      quantity
      product_option {
        id
        name
        type
        from_seats
        seat_value
        invoicing {
          price
          currency
          frequency
          tax_rate
        }
      }
      discount
      discount_percentage
      custom_price
    }
    organization {
      id
      name
    }
    totalSeats
    activeSeatAllocations
    billingCycle {
      id
      frequency
      startDate
      nextInvoicingDate
      lastDayIfCancelled
      reference
      startDay
      renewalDay
      lastDayIfCancelledDay
      hasStarted
      canPlanNextPeriod
    }
    endDate
    startDate
    startDay
    lastDay
    hasStarted
    hasEnded
    reference
  }
`
